import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// 🔴 Replace everything below with your actual Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyA4W5dgZq81Ux-VtW9M6QRSpHVdl_5xLRo",
  authDomain: "gumgumtr-96165.firebaseapp.com",
  projectId: "gumgumtr-96165",
  storageBucket: "gumgumtr-96165.firebasestorage.app",
  messagingSenderId: "234400264534",
  appId: "1:234400264534:web:d51e2cd8a37a7c2b07a6f7"
};

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

// Export Firestore and Storage for use in your app
export const db = getFirestore(app);
export const storage = getStorage(app);
